export enum NextPrevType {
  NEXT = 'next',
  PREV = 'previous',
}
